<template>
	<div style="height: 100%;">
		<div v-show="!emptyState" ref="charts" style="height: 100%;"></div>
		<c-empty v-show="emptyState"></c-empty>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library'
	import * as echarts from 'echarts'

	export default {
		data() {
			return {
				...getStore(this, 'digitalStore'),
				emptyState: false
			}
		},

		computed: {
			...mapStore('digitalStore', ['registerChart', 'px'])
		},

		mounted() {
			this.echartsObj = echarts.init(this.$refs.charts);
			this.registerChart(this.echartsObj);
		},

		methods: {
			update(data) {
				this.emptyState = !data.list.length;
				this.echartsObj.setOption({
					color: ['#02F4FF', '#19AEF1', '#FF414A', '#FFBA00', '#0A71F8', '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
					tooltip: {
						trigger: 'item'
					},
					series: {
						type: 'pie',
						center: ['50%', '50%'],
						radius: ['45%', '75%'],
						label: {
							formatter: '{b}\n{d}%',
							fontSize: this.px(13),
							color: '#fff'
						},
						data: data.list
					}
				});
			}
		}
	}
</script>

